import { combineReducers } from 'redux';

import { reducer as changeVariety } from './changeVarietyModule';
import { reducer as currentVariety } from './currentVarietyModule';

export default combineReducers({
	changeVariety,
	currentVariety,
});
